import { render, staticRenderFns } from "./MaturityRatings.vue?vue&type=template&id=08001248"
import script from "./MaturityRatings.vue?vue&type=script&lang=js"
export * from "./MaturityRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports